import React from "react";
import ReactDOM from "react-dom";
import App from "./app/App";
import reportWebVitals from "./reportWebVitals";
import {MercuryContextProvider} from "./context";
import {config} from "./config";

import {notification} from "antd";
import LoadingStar from "shared/components/LoadingStar";
import {BrowserRouter as Router, Routes, Route, useLocation, useNavigate} from "react-router-dom";

function RenderApp() {
    const location = useLocation(),
        navigate = useNavigate();

    console.log( "Turbo Mercury frontend")

    // @ts-ignore
    return (
        // @ts-ignore
        <MercuryContextProvider
            REACT_APP_AUTH_DOMAIN={config.AUTH_DOMAIN}
            REACT_APP_AUTH_CLIENT_ID={config.AUTH_CLIENT_ID}
            REACT_APP_AUTH_AUDIENCE={config.AUTH_AUDIENCE}
            Notifier={notification}
            Loader={LoadingStar}
            location={location}
            REACT_APP_API_URL={config.API_URL}
            REACT_APP_SERVICES_API_URL={config.SERVICES_API_URL}
            REACT_APP_BASE_URL={config.BASE_URL}
            REACT_APP_ENVIRONMENT_URL={config.ENVIRONMENT_URL}
            REACT_APP_WS_PATH={config.WS_PATH}
            navigate={navigate}
            loginPath="/login"
        >
            <Routes>
                <Route path="*" element={<App/>}/>
            </Routes>
        </MercuryContextProvider>

    );
}

ReactDOM.render(
    <Router>
        <RenderApp/>
    </Router>,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
